import React from 'react';
import { Box, Loader } from '@wix/design-system';
import { TextTyper } from './common/TextTyper/TextTyper';
import { WidgetButton } from '../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { useAutoScroll } from './common/useAutoScroll';
import styles from './PmaOnboardingWidget.scss';
export const PmaOnboardingWidget = _ref => {
  let {
    data: {
      mainText,
      subText,
      aiCta,
      mainCta,
      secondaryCta
    },
    context
  } = _ref;
  const [mainTextTypingEnded, setMainTextTypingEnded] = React.useState(false);
  const [subTextTypingEnded, setSubTextTypingEnded] = React.useState(false);
  const widgetRef = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  useAutoScroll(widgetRef);
  return /*#__PURE__*/React.createElement(Box, {
    ref: widgetRef,
    direction: "vertical",
    gap: "18px"
  }, /*#__PURE__*/React.createElement(TextTyper, {
    text: mainText,
    typingSpeed: 10,
    onTypingEnd: () => setMainTextTypingEnded(true)
  }), mainTextTypingEnded && subText && /*#__PURE__*/React.createElement(TextTyper, {
    text: subText,
    typingSpeed: 10,
    onTypingEnd: () => setSubTextTypingEnded(true)
  }), (subTextTypingEnded || mainTextTypingEnded && !subText) && /*#__PURE__*/React.createElement(Box, {
    gap: "12px",
    verticalAlign: "middle",
    marginTop: "12px",
    direction: "vertical",
    align: "left"
  }, aiCta && /*#__PURE__*/React.createElement(WidgetButton, {
    type: "button",
    size: "medium",
    skin: 'ai',
    selectedValues: [aiCta.respondText],
    selectedTitles: [aiCta.label],
    respondText: aiCta.respondText,
    context: context,
    onClick: () => setLoading(true),
    className: styles.PmaOnboardingWidgetAiButton,
    icon: loading ? undefined : {
      name: 'SparklesFilled',
      place: 'prefix'
    },
    sideEffect: aiCta.sideEffect
  }, loading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : aiCta.label), mainCta && /*#__PURE__*/React.createElement(WidgetButton, {
    type: "button",
    size: "medium",
    skin: 'inverted',
    selectedValues: [mainCta.respondText],
    selectedTitles: [mainCta.label],
    respondText: mainCta.respondText,
    context: context,
    sideEffect: mainCta.sideEffect,
    disabled: disabled,
    onClick: () => setDisabled(true)
  }, mainCta.label), secondaryCta && /*#__PURE__*/React.createElement(WidgetButton, {
    type: "button",
    size: "medium",
    skin: 'inverted',
    selectedValues: [secondaryCta.respondText],
    selectedTitles: [secondaryCta.label],
    respondText: secondaryCta.respondText,
    context: context,
    sideEffect: secondaryCta.sideEffect,
    disabled: disabled,
    onClick: () => setDisabled(true)
  }, secondaryCta.label)));
};
export const PMA_ONBOARDING_WIDGET = 'PMA_ONBOARDING_WIDGET';
//# sourceMappingURL=PmaOnboardingWidget.js.map